import { z } from 'zod'

export const OepLifecycleStatus = {
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  SCHEDULED: 'SCHEDULED',
  PAUSED: 'PAUSED',
  LIVE: 'LIVE',
  CLOSED: 'CLOSED',
} as const
export const OepLifecycleStatusSchema = z.nativeEnum(OepLifecycleStatus)
export type OepLifecycleStatus = z.infer<typeof OepLifecycleStatusSchema>

export const ChecklistItemStatus = {
  PASS: 'PASS',
  WARN: 'WARN',
  FAIL: 'FAIL',
} as const
export const ChecklistItemStatusSchema = z.nativeEnum(ChecklistItemStatus)
export type ChecklistItemStatus = z.infer<typeof ChecklistItemStatusSchema>

export const AuditActionType = {
  APPROVED: 'APPROVED',
  CHANGES_REQUESTED: 'CHANGES_REQUESTED',
  WARNING_ACKNOWLEDGED: 'WARNING_ACKNOWLEDGED',
  READINESS_EVALUATED: 'READINESS_EVALUATED',
} as const
export const AuditActionTypeSchema = z.nativeEnum(AuditActionType)
export type AuditActionType = z.infer<typeof AuditActionTypeSchema>
